export function normalizeUrl(url) {
    if (!url) return "";
    return /^https?:\/\//i.test(url) ? url : "https://" + url;
}

export function prettyUrl(url) {
    return (url || "").replace(/^https?:\/\//i, "").replace(/\/$/, "");
}

export function productTags(dealer, lang) {
    const pg = dealer.pg || {};
    const value = pg[lang];
    if (!value) return [];
    return String(value).split(/[,;\/]/).map(s => s.trim()).filter(Boolean);
}

// dealer.lvl is the ordinal of the BC enum DCMHGServicePartnerLvl, delivered via
// additional_data.servicePartnerLvl:
//   0 = kein Partner, 1 = Fachpartner, 2 = Servicepartner, 3 = Fachpartner und Servicepartner
// Keep this in sync with the enum in the dc.mhg.dynamiccommerce extension — the
// roleLabel_* / linkLabel_* text constants are keyed by the same ordinals.
export function matchesFilter(dealer, activeFilter) {
    const lvl = parseInt(dealer.lvl) || 0;
    if (activeFilter === "advisor") return lvl === 1 || lvl === 3;
    if (activeFilter === "service") return lvl === 2 || lvl === 3;
    return true;
}

export function dealerViewModel(dealer, config) {
    const lvl = parseInt(dealer.lvl) || 0;
    const cityLine = [dealer.postCode, dealer.city].filter(Boolean).join(" ");
    return {
        lvl,
        headline: dealer.name,
        hasRoleLabel: !!config.roleLabel[lvl],
        roleLabel: config.roleLabel[lvl] || '',
        hasAddress: !!dealer.address,
        address: dealer.address || '',
        hasCityLine: !!cityLine,
        cityLine: cityLine,
        hasPhone: !!dealer.phone,
        phone: dealer.phone || '',
        hasEmail: !!dealer.email,
        email: dealer.email || '',
        hasHomepage: !!dealer.homepage,
        homepageHref: dealer.homepage ? normalizeUrl(dealer.homepage) : '',
        homepageText: dealer.homepage ? prettyUrl(dealer.homepage) : ''
    };
}
